<template>
	<div class="small-12 addForm editLease animated fadeInRight border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
        <div class="small-12 columns panelMenuWrapper" v-if="lease">
            <div class="small-12 formTitle border-bottom">
                <h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Edit Lease
					</span>
					<i class="material-icons-outlined transition" @click="closeEditLeaseMenu()">cancel</i>
				</h2>
                <div class="small-12" v-if="resident">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p>
								<b>For: </b>
								{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
							</p>
						</li>
					</ul>
				</div>	
            </div>
            <div class="small-12 formBody" style="padding-top:20px;">
                <div class="small-12 sectionTitle flex first">
					<h2>Lease Information</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Status<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="lease_options">
						<select name="status" class="small-12" v-model="status.value" @change="statusValidation($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="statusOption.value" v-for="(statusOption, statusOptionIndex) in lease_options.statuses" :selected="status.value == statusOption.value ? true : false" :key="statusOptionIndex">{{statusOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="status.error.show">
						<small class="cRed small-12">{{status.error.title}}</small>
					</div>
				</fieldset>
                <fieldset class="small-12 flex inputGroup">
					<label class="small-12">Lease Type<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align" v-if="lease_options">
						<select name="lease_type" class="small-12" v-model="lease_type.value" @change="leaseTypeValidation($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="typeOption.value" v-for="(typeOption, typeOptionIndex) in lease_options.lease_types_residential" :selected="lease_type.value == typeOption.value ? true : false" :key="typeOptionIndex">{{typeOption.title}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="lease_type.error.show">
						<small class="cRed small-12">{{lease_type.error.title}}</small>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Lease Term</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<div class="small-12">
						<label class="small-12">Start Date<em class="cRed">*</em></label>
                        <div class="small-12" @click="setCalendarPickerIndex($event)">
                            <datetime v-model="start_date.value" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateStartDate($event)"></datetime>
                        </div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="start_date.error.show">
						<small class="cRed small-12">{{start_date.error.title}}</small>
					</div>
				</fieldset>
                <fieldset class="small-12 flex inputGroup">
					<div class="small-12">
						<label class="small-12">End Date<em class="cRed">*</em></label>
                        <div class="small-12" @click="setCalendarPickerIndex($event)">
						    <datetime v-model="end_date.value" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateEndDate($event)"></datetime>
                        </div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="end_date.error.show">
						<small class="cRed small-12">{{end_date.error.title}}</small>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Lease Documents</h2>
				</div>
                <fieldset class="small-12 flex inputGroup" style="margin-bottom:30px;">
					<div class="small-12 flex vertical-align">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="signature.value" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Signature Acquired</b></p>
							<span class="small-12 columns">Do you have a signed lease?</span>
						</div>
					</div>
					<div class="small-12 animated fadeIn leaseDocumentUpload" style="margin-top:20px;" v-if="signature.value">
						<label class="small-12">Upload lease documents</label>
						<div class="small-12 fileUploadWrap borderRadius7">
							<div class="small-12 fileUploadArea upload flex vertical-align justify-center">
								<file-pond ref="pond" allow-multiple="false" max-files="1" accepted-file-types="image/jpeg, image/png, application/pdf" :server="{  process, load }" @error="handleFilePondError" :allowFileSizeValidation="true" max-file-size="1000MB" label-max-file-size-exceeded="File is too large."></file-pond>
							</div>
						</div>
						<div class="small-12 uploadedDocuments" v-if="documents.value.length > 0">
							<label class="small-12">Upload Documents</label>
							<ul class="small-12 flex float-left">
								<li class="small-12 columns" v-for="(doc, docIndex) in documents.value" :key="docIndex">
									<uploaded-document :doc="doc"/>
								</li>
							</ul>
						</div>
					</div>
				</fieldset>
                <div class="small-12 sectionTitle flex">
					<h2>Lease Renewal</h2>
				</div>
                <fieldset class="small-12 flex inputGroup">
					<div class="small-12 flex vertical-align">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="send_notice.value" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14" @change="validateNoticeDate($event)"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Renewal Notice</b></p>
							<span class="small-12 columns">Send your resident a renewal notice before lease expires?</span>
						</div>
					</div>
					<div class="small-12 animated fadeIn" style="margin-top:16px; position: relative; z-index:2;" v-if="send_notice.value">
						<label class="small-12">Notice Date<em class="cRed">*</em></label>
						<div class="small-12" @click="setCalendarPickerIndex($event)">
                            <datetime v-model="notice_date.value" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="validateNoticeDate($event)"></datetime>
                        </div>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="notice_date.error.show">
						<small class="cRed small-12">{{notice_date.error.title}}</small>
					</div>
				</fieldset>
            </div>
        </div>
        <div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton borderRadius4 flex justify-center vertical-align" @click="updateLeaseHandler()" v-if="enableUpdateButton">
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Lease
            </a>
            <a class="disabledButton borderRadius4 flex justify-center vertical-align" v-else>
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">save</i>
                Save Lease
            </a>
            <a class="deleteButton borderRadius4 flex justify-center vertical-align" v-if="open_paid_invoices && open_paid_invoices.length == 0 && lease_current_rent_terms && lease_current_rent_terms.length == 0" @click="deleteLeaseHandler()">
                Delete Lease
            </a>
            <a class="whiteButton plain borderRadius4 flex justify-center vertical-align border" style="margin-left:20px;" @click="showDeleteButtonInfo()" v-else>
                <i class="material-icons-outlined">info</i>
                Delete Lease
            </a>
		</div>
    </div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { FilepondService } from '@/mixins/services/filepond/FilepondService'

	// Import the events
	import { GetLeaseOptions } from '@/events/config/GetLeaseOptions'
    import { UploadFileToStorage } from '@/events/files/UploadFileToStorage'
    import { GetActiveLease } from '@/events/leases/GetActiveLease'
    import { UpdateLease } from '@/events/leases/UpdateLease'
    import { GetLeaseCurrentRentTerms } from '@/events/rent/GetLeaseCurrentRentTerms'
    import { GetOpenPaidInvoices } from '@/events/invoices/GetOpenPaidInvoices'
    import { DeleteLease } from '@/events/leases/DeleteLease'
    import { GetUser } from '@/events/nestd-residents/GetUser'

    // Import the components
	import UploadedDocument from '@/components/property/leases/UploadedDocument.vue'
	import { Datetime } from 'vue-datetime'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'EditLeaseMenu',

		/*
		**  Register the components
		*/

		components: {

			Datetime,
            UploadedDocument

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
            GetLeaseOptions,
            FilepondService,
            UploadFileToStorage,
            GetActiveLease,
            UpdateLease,
            GetLeaseCurrentRentTerms,
            GetOpenPaidInvoices,
            DeleteLease,
            GetUser

		],

		/*
		**  Set the props
		*/

		props: {

            menu_action: {
                type: Boolean,
                default: false
            },
            lease: {
                type: Object,
                default: () => null
            },
            resident: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			open_menu: false,
            enableUpdateButton: false,
            enableDeleteButton: false,
            edit_lease_form_props_set: false,
            edit_lease_processing: false,
            form_error: false,
            deleteButtonDescription: 'Please make sure there are not any paid or open invoices and an active rent term before deleting a lease.',
            status: {
                value: null,
                display_value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            lease_type: {
                value: null,
                display_value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            start_date: {
                value: null,
                display_value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            end_date: {
                value: null,
                display_value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            notice_date: {
                value: null,
                display_value: null,
                error: {
                    title: null,
                    show: false
                }
            },
            signature: {
                value: null
            },
            documents: {
                value: null
            },
            send_notice: {
                value: null
            }

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openTheMenu();

				}

			},

            lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					**  Set the form props
					**  @method: @here
					*/

					if (lease) this.setEditLeaseFormProps();

				}

			},

            file_download: {

				immediate: true, // Load on created
				handler(file_download) {

					/*
					**  Set the documents prop
					**  @method: @here
					*/

					if (file_download) this.setDocumentsProp();
				}

			},

            send_notice_value: {

                immediate: true, // Load on created
				handler(send_notice_value) {

					/*
					**  Reset the prop
					**  @method: @here
					*/

					if (!send_notice_value) this.notice_date.error.show = false;

				}

            },

            resident: {

				immediate: true, // Load on created
				handler(resident) {

					/*
					**  Active lease check
					**  @method: @Events/Leases/GetActiveLease
					*/

					if (resident) this.getActiveLeaseHandler(this.$route.params.id, resident.id);

                    /*
					**  Active rent check
					**  @method: @Events/Rent/GetLeaseCurrentRentTerms
					*/

                    if (resident) this.getLeaseCurrentRentTermsHandler(this.lease.id);

                    /*
					**  Get the residents portal user
					**  @method: @Events/nestd-residents/GetUser
					*/

                    if (resident) this.getUserHandler(resident.id);

				}

			},

            get_lease_current_rent_terms_complete: {

                immediate: true, // Load on created
				handler(get_lease_current_rent_terms_complete) {

					/*
					**  Open or paid invoices check
					**  @method: @here
					*/

					if (get_lease_current_rent_terms_complete) this.getTheInvoices();

				}

            },

            edited_status: {

				immediate: true, // Load on created
				handler(edited_status) {

					/*
					**  Status validation
					**  @method: @here
					*/

					if (edited_status && this.edit_lease_form_props_set) this.statusValidation();

				}

			},

            edited_lease_type: {

				immediate: true, // Load on created
				handler(edited_lease_type) {

					/*
					**  Lease type validation
					**  @method: @here
					*/

					if (edited_lease_type && this.edit_lease_form_props_set) this.leaseTypeValidation();

				}

			},
            edited_start_date: {

				immediate: true, // Load on created
				handler(edited_start_date) {

					/*
					**  Start date validation
					**  @method: @here
					*/

					if (edited_start_date && this.edit_lease_form_props_set) this.validateStartDate();

				}

			},
            edited_end_date: {

				immediate: true, // Load on created
				handler(edited_end_date) {

					/*
					**  End date validation
					**  @method: @here
					*/

					if (edited_end_date && this.edit_lease_form_props_set) this.validateEndDate();

				}

			},
            edited_notice_date: {

				immediate: true, // Load on created
				handler(edited_notice_date) {

					/*
					**  Notice date validation
					**  @method: @here
					*/

					if (edited_notice_date && this.edit_lease_form_props_set) this.validateNoticeDate();

				}

			},

		},

        /*
        ** Do this first
        */

        mounted() {

			/*
			**  Get the config options
			**  @method: @/Events/Config/GetLeaseOptions
			*/

        	this.getLeaseOptionsHandler();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			openTheMenu: function() {

				try {

					/*
					**  Display the menu
					**  @prop: @here
					*/

					this.open_menu = true;
					
					/*
                    **  Reset validation props
                    **  @method: @here
                    */

                    this.resetValidationProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the Edit Lease Menu.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'cK9DEewBRq6HyKvOZJOo',
                        error: e
                    });

				}

			},

            closeEditLeaseMenu: function() {

				try {
 
					/*
                    **  Close the menu
					**  @prop: @here
					*/

					this.open_menu = false;

					/*
                    **  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeEditLeaseMenu', true);

					/*
                    **  Reset the prop
					**  @method: @here
					*/

					this.resetValidationProps();

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the Edit Lease Menu.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'FqrbEIfCmgc1bc406sB6',
                        error: e
                    });

				}

			},

            getTheInvoices: function() {

                try {

                    /*
                    **  Get the open and paid invoices
					**  @method: @Events/Invoices/GetOpenPaidInvoices
					*/

                    if (this.lease_current_rent_terms.length > 0) {

                        this.lease_current_rent_terms.forEach(rent => {

                            this.getOpenPaidInvoicesHandler(rent.id);

                        });

                    }

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Get the open and paid invoices from the current rent term.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'WvJ0hheyUIW660rG73xw',
                        error: e
                    });

                }

            },

            enableDeleteButtonCheck: function() {

                try {

                    /*
                    **  Check if we can enable the delete button
                    **  @prop: @here
                    */

                    if (this.open_paid_invoices && this.open_paid_invoices.length == 0 && this.lease_current_rent_terms && this.lease_current_rent_terms.length == 0) {

                        /*
                        **  If no paid/open invoices exist 
                        **  @prop: @here
                        */

                        this.enableDeleteButton = true;

                    } else if (this.open_paid_invoices && this.open_paid_invoices.length > 0) {

                        /*
                        **  Set the prop
                        **  @prop: @here
                        */

                        this.deleteButtonDescription = 'Unable to delete this lease because 1 or more invoices exist that have been paid or are open.';

                        /*
                        **  If no paid/open invoices exist 
                        **  @prop: @here
                        */

                        this.enableDeleteButton = false;

                    } else if (this.lease_current_rent_terms && this.lease_current_rent_terms.length > 0) {

                        /*
                        **  If no paid/open invoices exist 
                        **  @prop: @here
                        */

                        this.enableDeleteButton = false;

                        /*
                        **  Set the prop
                        **  @prop: @here
                        */

                        this.deleteButtonDescription = 'Unable to delete this lease because a current rent term is active.';

                    }

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Enable delete button check.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'wFNfhObI4BgzGZjlT5gY',
                        error: e
                    });

                }

            },

            resetValidationProps: function() {

                try {

                    /*
                    **  Reset the props
                    **  @props: @here
                    */

                    this.enableUpdateButton = false;
					this.enableDeleteButton = false;
					this.form_error = false;
                    this.edit_lease_form_props_set = false;
                    this.edit_lease_processing = false;


                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the validation props for the edit lease menu.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'K8ltSIckXsdbxXOIikFk',
						error: e
					});

                }

            },

            setEditLeaseFormProps: function() {

                try {

                    /*
                    **  Set the term dates props
                    **  @props: @here
                    */

                    this.status.value = this.lease.attributes.status;
                    this.lease_type.value = this.lease.type;
                    this.start_date.value = moment(this.lease.attributes.details.start_date * 1000).format();
                    this.end_date.value = moment(this.lease.attributes.details.end_date * 1000).format();
                    this.documents.value = this.lease.links.documents;
                    this.send_notice.value = this.lease.attributes.renewal.send_notice;
                    this.notice_date.value = moment(this.lease.attributes.renewal.notice_date * 1000).format();

                    /*
                    **  Complete the props setting
                    **  @props: @here
                    */

                    this.edit_lease_form_props_set = true;

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the form props for the edit lease menu.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'SeonthLQJid8GQkw6sPb',
						error: e
					});

                }

            },

            statusValidation: function(event) {

                try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.status.value == '' || !this.status.value || this.status.value.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error.show = true;
                        this.status.error.title = 'This is a required field.';

                    } else if (event && this.active_lease && this.new_lease.attributes.status == 'active' && this.active_lease.id !== this.lease.id) {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error.show = true;
                        this.status.error.title = 'An active lease already exists for this resident.';

					} else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.status.error.show = false;
                        this.status.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					if (event) this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the status.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'zjHz9IMie2nXsf3Qhc6n',
						error: e
					});

                }

			},

            leaseTypeValidation: function(event) {

                try {

                    if (this.lease_type.value == '' || !this.lease_type.value || this.lease_type.value.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.lease_type.error.show = true;
                        this.lease_type.error.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.lease_type.error.show = false;
                        this.lease_type.error.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					if (event) this.enableSubmitButtonCheck();

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the lease type.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'rF0TCdqLvSqJjncQowzr',
						error: e
					});

                }

			},

            validateStartDate: function(event) {

				try {

                    if (event && !moment(event).isSame(this.start_date.value)) {

                        /*
                        **  Set the vars
                        */

                        let startDate = moment(this.start_date.value),
                            todaysDate = moment(),
                            inThePast = startDate.diff(todaysDate, 'days');

                        /*
                        **  Set the vars
                        */

                        if (inThePast < 0) {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.start_date.error.show = true;
                            this.start_date.error.title = 'Your lease cannot start in the past.';

                        } else {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.start_date.error.show = false;
                            this.start_date.error.title = null;

                        }

                        /*
                        **  Check if we can enable the submit button
                        **  @method: @here
                        */

                        this.enableSubmitButtonCheck();

                    }

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the start date.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'ZkA972g2nWRCHeqX2G8S',
						error: e
					});

				}

			},

            validateEndDate: function(event) {

				try {

                    if (event && !moment(event).isSame(this.end_date.value)) {

                        /*
                        **  Set the vars
                        */

                        let startDate = moment(this.start_date.value),
                            endDate = moment(this.end_date.value),
                            endBeforeStart = endDate.diff(startDate, 'days');

                        /*
                        **  Set the vars
                        */

                        if (endBeforeStart < 0) {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.end_date.error.show = true;
                            this.end_date.error.title = 'Your end date cannot be set before the start date.';

                        } else {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.end_date.error.show = false;
                            this.end_date.error.title = null;

                        }

                        /*
                        **  Check if we can enable the submit button
                        **  @method: @here
                        */

                        this.enableSubmitButtonCheck();

                    }

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the end date.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'bMaXqOMtVAgYyk6bgBSN',
						error: e
					});

				}

			},

            validateNoticeDate: function(event) {

				try {

                    if (event && !moment(event).isSame(this.notice_date.value)) {

                        /*
                        **  Set the vars
                        */

                        let renewalDate = moment(this.notice_date.value),
                            startsAt = moment(this.start_date.value),
                            renewalNoticeBefore = startsAt.diff(renewalDate, 'days');

                        if (this.send_notice && this.notice_date.value == '' || this.send_notice && !this.notice_date.value || this.send_notice && this.notice_date.value.length == 0) {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.notice_date.error.show = true;
                            this.notice_date.error.title = 'This is a required field.';

                        } else if (renewalNoticeBefore > 0) {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.notice_date.error.show = true;
                            this.notice_date.error.title = 'Cannot be before the lease term start date.';

                        } else {

                            /*
                            **  Set the error props
                            **  @props: @here
                            */

                            this.notice_date.error.show = false;
                            this.notice_date.error.title = null;

                        }

                        /*
                        **  Check if we can enable the submit button
                        **  @method: @here
                        */

                        this.enableSubmitButtonCheck();

                    }

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to validate the lease type.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'lvGVTqAaVm1K1nWCCmGe',
						error: e
					});

                }

			},

            enableSubmitButtonCheck: function() {

                try {

					/*
					**  Can we enable the submit button?
					**  @props: @here
					*/

                    if (this.status.value && this.lease_type.value && !this.status.error.show && !this.lease_type.error.show && !this.start_date.error.show && !this.end_date.error.show && !this.notice_date.error.show) {

                        /*
						**  Enable the update button
						**  @prop: @here
						*/

						this.enableUpdateButton = true;

					} else {

						/*
						**  Disable the update button
						**  @prop: @here
						*/

						this.enableUpdateButton = false;

					}

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to perform submit button check.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'xQgmFw7bOPs40mERyAOt',
						error: e
					});

                }

            },

            setCalendarPickerIndex: function(event) {

                try {

                    /*
					**  Emit the event
					**  @service: @Vue
					*/

                    this.$emit('setCalendarPickerIndex', true);
                    
                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the set calendar picker index event.',
						errorType: 'Application',
						section: 'Edit Lease',
						uid: 'TKIRLBwLTU2QsQw0ytF1',
						error: e
					});

                }

            },

            setDocumentsProp: function() {

				try {

					/*
                    **  Set the documents prop
                    **  @prop: @here
                    */

					this.documents.value.push({
						id: this.file_name,
						title: this.file_name + '.' + this.file_extension,
						storage_url: this.download_url,
						created_at: moment().unix()
					});

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Reset the documents prop.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'aHzGDOXpTE5gfe8UCnSP',
                        error: e
                    });

				}

			},

            showDeleteButtonInfo: function() {

                try {

                    this.$swal('Trying to delete?', this.deleteButtonDescription, 'info');

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Show the delete button info modal.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'hdDQ6Wwo20pCpkbnMOAS',
                        error: e
                    });

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			send_notice_value: function() {

                return this.send_notice.value;

            },
            edited_status: function() {

				return this.status.value;

			},
            edited_lease_type: function() {

				return this.lease_type.value;

			},
            edited_start_date: function() {

				return this.start_date.value;

			},
            edited_end_date: function() {

				return this.end_date.value;

			},
            edited_notice_date: function() {

				return this.notice_date.value;

			},

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>